module.exports = __webpack_public_path__ + "img/king.5d4e4a97.svg";